import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
`;

export default Wrapper;
